import { Routes } from '@angular/router';
import { AbstractRouteGuard } from '../modules/microsoft-authentication-library/route-guard/route-guard.abstract';
import { NavigationRoutes } from './app.routes.definition';

const OUTLET_NAME = 'rightDrawer';

export const RIGHT_DRAWER_ROUTES: Routes = [
    {
        path: 'campaign-create-master/:organizationId/:campaignId',
        loadComponent() {
            return import('../modules/campaigns/campaign-create-master/campaign-create-master.component').then(m => m.CampaignCreateMasterComponent);
        },
        canActivate: [AbstractRouteGuard],
        outlet: OUTLET_NAME,
    },
    {
        path: NavigationRoutes.rightDrawer.campaignTypeSelector.path,
        loadComponent() {
            return import('../modules/campaigns/campaign-type-selector/campaign-type-selector.component').then(m => m.CampaignTypeSelectorComponent);
        },
        canActivate: [AbstractRouteGuard],
        outlet: OUTLET_NAME,
    },
    {
        path: NavigationRoutes.rightDrawer.geolocationDetails.path,
        loadComponent() {
            return import('../modules/campaigns/geolocation-details/geolocation-details.component').then(m => m.GeolocationDetailsComponent);
        },
        canActivate: [AbstractRouteGuard],
        outlet: OUTLET_NAME,
    },
    {
        path: NavigationRoutes.rightDrawer.notificationDetails.path,
        loadComponent() {
            return import('../modules/campaigns/notification-details/notification-details.component').then(m => m.NotificationDetailsComponent);
        },
        canActivate: [AbstractRouteGuard],
        outlet: OUTLET_NAME,
    },
    {
        path: 'send-notification-create-master/:organizationId/:campaignId',
        loadComponent() {
            return import('../modules/notifications/send-notification-create-master/send-notification-create-master.component').then(m => m.SendNotificationCreateMasterComponent);
        },
        canActivate: [AbstractRouteGuard],
        outlet: OUTLET_NAME,
    }
]